export const rupees = (value?: number | null): string =>
  Number(value ?? 0).toLocaleString('en-IN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

export const money = (value?: number | null): string => (value ? rupees(value) : '—');

export const shortDate = (value?: string | null): string =>
  value ? String(value).slice(0, 10) : '—';

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const longDate = (value?: string | null): string => {
  const matched = /^(\d{4})-(\d{2})-(\d{2})/.exec(value ?? '');
  const month = matched ? MONTHS[Number(matched[2]) - 1] : undefined;
  return matched && month ? `${matched[3]} ${month} ${matched[1]}` : '-';
};

const TIME_ZONE = 'Asia/Kolkata';

const istDate = new Intl.DateTimeFormat('en-CA', {
  timeZone: TIME_ZONE,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
});

const istTime = new Intl.DateTimeFormat('en-GB', {
  timeZone: TIME_ZONE,
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23',
});

export const dateTime = (value?: string | null): string => {
  if (!value) return '—';
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return String(value).slice(0, 16).replace('T', ' ');
  return `${istDate.format(parsed)} · ${istTime.format(parsed)}`;
};

export const isoDaysAgo = (days: number): string =>
  istDate.format(new Date(Date.now() - days * 86_400_000));

export const today = (): string => istDate.format(new Date());

export const STATUS_LABEL: Record<string, string> = {
  success: 'Success',
  failed: 'Failed',
  pending: 'Pending',
};

export const initials = (name?: string | null): string =>
  (name ?? '')
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word.charAt(0).toUpperCase())
    .join('');

interface IFailureDetail {
  error_code: string | null;
  error_message: string | null;
  field9: string | null;
}

const NO_ERROR = /^no error$/i;

// The gateway's own wording explains a failure; the bare code (E1605, E1206, …) is the last resort.
export const failureReason = ({
  error_code,
  error_message,
  field9,
}: IFailureDetail): string | null => {
  const message = error_message?.trim();
  if (message && !NO_ERROR.test(message)) return message;
  return field9?.trim() || error_code;
};
